
import { defineComponent, ref, watchEffect } from "vue";
import { useAuthStore } from "@/stores/auth";

export default defineComponent({
  name: "Setting",
  setup() {
    const { state, updateUser } = useAuthStore();
    const displayName = ref("");
    const photoURL = ref("");
    const update = () =>
      updateUser({ displayName: displayName.value, photoURL: photoURL.value });

    watchEffect(() => {
      displayName.value = state.displayName;
      photoURL.value = state.photoURL;
    });

    return { displayName, photoURL, update };
  },
});
